import React from 'react';

type InputFieldPropsBase = {
  id: string;
  name: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  value: string | null;
  onBlur: () => void;
  error: boolean;
  helperText: string;
  containerClass?: string;
  containerErrorClass?: string;
  helperTextClass?: string;
  helperTextErrorClass?: string;
} & (
  | {
      onChange: (value: string) => void;
      dontUnpackValue?: false;
    }
  | {
      onChange: (value: React.ChangeEvent) => void;
      dontUnpackValue: true;
    }
);

type InputFieldPropsInput = InputFieldPropsBase & {
  type: string;
  textarea?: never;
};

type InputFieldPropsTextArea = InputFieldPropsBase & {
  type?: never;
  textarea: true;
};

function InputField(props: InputFieldPropsInput): React.ReactElement;
function InputField(props: InputFieldPropsTextArea): React.ReactElement;

function InputField({
  id,
  name,
  type,
  placeholder,
  className,
  disabled,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  textarea,
  containerClass,
  containerErrorClass,
  helperTextClass,
  helperTextErrorClass,
  dontUnpackValue,
  ...restProps
}: InputFieldPropsInput | InputFieldPropsTextArea): React.ReactElement {
  return (
    <div
      className={containerClass + (error && containerErrorClass ? ' ' + containerErrorClass : '')}
    >
      {textarea ? (
        <textarea
          id={id}
          className={className}
          name={name}
          placeholder={placeholder}
          disabled={disabled}
          value={value || ''}
          // @ts-ignore
          onChange={e => onChange(dontUnpackValue ? e : e.target.value)}
          onBlur={onBlur}
          {...restProps}
        />
      ) : (
        <input
          type={type}
          id={id}
          className={className}
          name={name}
          placeholder={placeholder}
          disabled={disabled}
          value={value || ''}
          onChange={e =>
            // @ts-ignore
            onChange(dontUnpackValue ? e : e.target.value)
          }
          onBlur={onBlur}
          {...restProps}
        />
      )}
      <span
        className={
          helperTextClass + (error && helperTextErrorClass ? ' ' + helperTextErrorClass : '')
        }
        style={{ visibility: !helperText ? 'hidden' : undefined }}
      >
        {helperText || 'x'}
      </span>
    </div>
  );
}

export default InputField;
